<template>
  <div class="pt-0 gap-4 grid grid-cols-6">
    <TopicsListItem
      v-for="(topic, index) of sortedList"
      :key="topic.slug"
      class="col-span-6 md:col-span-3 xl:col-span-2"
      :topic="topic"
      :index="index"
      :section-slug="sectionSlug"
      @click="handleSelect"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import TopicsListItem from '@/components/Hub/Topics/TopicsListItem.vue'

export default {
  name: 'HubTopicsList',

  components: { TopicsListItem },

  inject: {
    isDemo: { default: false }
  },

  props: {
    list: { type: Array, default: () => [] },
    sectionSlug: { type: String, required: true }
  },

  computed: {
    sortedList() {
      // Sort by level weight
      const levels = {
        basic: 1,
        intermediate: 2,
        advanced: 3
      }

      // inside level sort by name
      const insideLevelSort = (a, b) => a.name.localeCompare(b.name)

      return [...this.list].sort((a, b) => {
        const levelA = levels[a.level]
        const levelB = levels[b.level]

        return levelA - levelB || insideLevelSort(a, b)
      })
    }
  },

  methods: {
    ...mapMutations('ui', {
      setUiDemoTopicModal: 'SET_UI_DEMO_TOPIC_MODAL'
    }),

    handleSelect(topic) {
      if (this.isDemo) {
        this.setUiDemoTopicModal({
          isVisible: true,
          sectionSlug: this.sectionSlug,
          topicSlug: topic.slug
        })
      } else {
        this.$router.push({
          name: 'hub.exercises',
          params: { sectionSlug: this.sectionSlug, topicSlug: topic.slug }
        })
      }
    }
  }
}
</script>
